<div class="SLV2-user-feedback-popup">
    <button class="SLV2-popup-close-btn" (click)="onConfirmClick()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
    </button>
    <div class="SLV2-popup-content-area">
        <div class="SLV2-question-box">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/flag-black-icon.svg" class="SLV2-popup-flag" />
            <h1 class="SLV2-user-feedback-question">What didn't you like?</h1>
        </div>
        <ng-container *ngFor=" let report of reportOptions">
            <mat-checkbox color='primary' class="SLV2-user-feedback-opt custom-frame" [checked]="report.checked" (change)="report.checked = !report.checked" (change)="isUserSelectedChoice($event,report)"> {{report.reportOption}}</mat-checkbox>
        </ng-container>
       
        <!-- <mat-checkbox color='primary' class="SLV2-user-feedback-opt"> Contains wrong spellings</mat-checkbox>
        <mat-checkbox color='primary' class="SLV2-user-feedback-opt"> Some data is missing</mat-checkbox>
        <mat-checkbox color='primary' class="SLV2-user-feedback-opt"> Image is missing/wrong image</mat-checkbox> -->
        <p class="SLV2-user-feedback-err-dtls">Add error details (if any)</p>
        <textarea class="SLV2user-feedback-err-input" matInput name="questionErrorDetails" cols="35" rows="3" placeholder="Type here" (input)="onValueChange($event)" required></textarea>
    </div>
    <div class="SLV2-popup-actn-area">
        <button class="SLV2-popup-text-btn" (click)="onConfirmClick()">Cancel</button>
        <button class="SLV2-popup-solid-btn" (click)="onConfirmClick()" [disabled]="this.tempSelctedItems?.length <=0 && this.userMessage?.length <=0">Submit</button>
    </div>
</div>